import { Api } from "./api"

export class IndividualReportApi extends Api {
  constructor() {
    super('sample_reports', [])
  }
}
